<div class="toast-alert {{alert.severity}}">

  <div *ngIf="options.progressBar" class="toast-progress" [ngStyle]="{ 'width': width + '%' }"></div>

  <app-fn-ui-close-icon (closeClick)="remove()"></app-fn-ui-close-icon>

  <app-alert-item [alert]="alert" (detailsClick)="onDetailsClick()" (investigateClick)="onInvestigateClick()">
  </app-alert-item>
</div>